import { Component, OnInit, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { PageBase } from 'src/app/shared/library/page.base';
import { KindBoard } from 'src/utils/enums';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { TaskCost } from './taskcost';
import { TaskCostService } from './taskcost.service';

@Component({
    selector: 'cp-taskcost',
    templateUrl: './taskcost.component.html',
    styleUrls: ['./taskcost.component.css'],
    standalone: false
})
export class TaskCostComponent extends PageBase implements OnInit, OnChanges {

  @Input() taskitem: TaskItem;

  taskcost: TaskCost = new TaskCost();
  isHideLoading = true;

  constructor(private taskcostservice: TaskCostService,
              public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskitem) {
      this.isHideLoading = false;
      this.load();
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.taskcost.id = this.taskcost.percentage = this.taskcost.plannedvalue = 0;
    this.taskcost.balancevalue = this.taskcost.appropriatevalue = 0;
    this.taskitem = new TaskItem();
  }

  async load() {
    if(this.contextApplication.currentVision == KindBoard.Tarefa.valueOf())
    {
      this.taskcost = await this.taskcostservice.GetInfoTask(this.taskitem);
    }
    else
    {
      this.taskcost = await this.taskcostservice.GetInfoTaskByInput(this.taskitem);
    }
    this.isHideLoading = true;
  }

  onReceiveLiterals() {}
}
